import { Fragment, useEffect, useState } from 'react';
import { emptyContentfulPageResponse, getContentfulPage } from '../../api/content-service-api';
import { ContentfulPageResponse } from '../../api/types/content-api';
import { getKmxDocumentToReactComponents } from '../../utilities/contentful/RichTextRenderer';

interface ContentfulPageProps {
    entryId: string;
}

const ContentfulPage = ({ entryId }: ContentfulPageProps) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [contentfulPage, setContentfulPage] = useState<ContentfulPageResponse>(emptyContentfulPageResponse);

    useEffect(() => {
        getContentfulPage(entryId).then((contentfulPageResponse) => {
            setContentfulPage(contentfulPageResponse);
            setLoading(false);
        });
    }, [setLoading, setContentfulPage, entryId]);

    return (
        <div className="contentful-page-container">
            {loading ? (
                <div style={{ textAlign: 'center', paddingTop: '100px' }}>
                    <hzn-loading tone="brand" size="large"></hzn-loading>
                </div>
            ) : (
                contentfulPage.pageContent.content?.map((document, i) => (
                    <Fragment key={`${i}-content`}>{getKmxDocumentToReactComponents(document)}</Fragment>
                ))
            )}
        </div>
    );
};

export default ContentfulPage;
